import type { ButterflyData, ButterflyRelation } from '$lib/types';

type RelationHandler<Type> = (rel: ButterflyRelation, inc: ButterflyData[]) => Type;

const getRelation: RelationHandler<any> = (rel, inc) =>
  (rel && inc.find((i) => i.id === rel.id && i.type === rel.type)) || null;

export default getRelation;
